import { Preferences } from "../../profile/objects/preferences";
import { USER_TEAM_MODULE } from "../constants/userTeamConstants";
import { Column } from "../objects/column";

export const setUserTeamPreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === USER_TEAM_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'NAME':
                        columns.push({ label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'name' : order_by;
                        break;
                    case 'COUNTRIES':
                        columns.push({ label: 'countries', field_name: preference.field_name, checked: preference.active, order_by: 'countries', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'countries' : order_by;
                        break;
                    case 'EVENTS':
                        columns.push({ label: 'events', field_name: preference.field_name, checked: preference.active, order_by: 'events', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'events' : order_by;
                        break;
                    case 'USERS':
                        columns.push({ label: 'users', field_name: preference.field_name, checked: preference.active, order_by: 'users', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'users' : order_by;
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'created_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'last_author__username' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};